<span *ngFor="let deco of decorationInfoArray">
    <span *ngIf="deco.displayText && deco.isPlainText"
        tabindex="0"
        [attr.aria-label]="deco.displayText"
        [innerHtml]="deco.displayText" 
        [ngClass]="{
            'bold': deco.isBold,
            'strike-through': deco.isStrikeThrough
        }"
    ></span>
    <a *ngIf="deco.displayText && !deco.isPlainText && deco.uiSref"
        [innerHtml]="deco.displayText"
        [ngClass]="{
            'xm-btn-link-light': deco.isLink && decorationInfoArray.length === 1,
            'inline-link': deco.isLink && decorationInfoArray.length > 1,
            'xm-btn-primary-light': deco.isPrimary,
            'xm-btn-secondary-light': deco.isSecondary
        }"
        [target]="deco.newTab ? '_blank' : ''"
        [uiSref]="deco.uiSref"
        [uiParams]="deco.uiParams"
    ></a>
    <a *ngIf="deco.displayText && !deco.isPlainText && deco.absoluteUrl"
        [innerHtml]="deco.displayText"
        [ngClass]="{
            'xm-btn-link-light': deco.isLink && decorationInfoArray.length === 1,
            'inline-link': deco.isLink && decorationInfoArray.length > 1,
            'xm-btn-primary-light': deco.isPrimary,
            'xm-btn-secondary-light': deco.isSecondary
        }"
        [target]="deco.newTab ? '_blank' : ''"
        [href]="deco.absoluteUrl"
    ></a>
</span>
<ng-content></ng-content>
